export const GA4EventNames = {
    KYC_userclicked_verifyaadhar: "KYC_userclicked_verifyaadhar_web",
    KYC_useraadhar_verified: "KYC_useraadhar_verified_web",
    KYC_userclicked_verifygst: "KYC_userclicked_verifygst_web",
    KYC_usergst_verified: "KYC_usergst_verified_web",

    // Home page events
    Website_homepage_btn_click: "Website_homepage_btn_click_web",
    Website_homepage_btn_click_location: "Website_homepage_btn_click_location_web",
    Homepage_what_can_we_do: "Homepage_what_can_we_do_web",
    Homepage_meet_india_transporter_change_city_after_selection:
        "Homepage_meet_india_transporter_change_city_after_selection_web",
    Homepage_meet_india_book_right_load_for_you: "Homepage_meet_india_book_right_load_for_you_web",
    Homepage_meet_india_after_right_lorry_Category_selection:
        "Homepage_meet_india_after_right_lorry_Category_selection_web",
    Homepage_meet_india_find_transporter: "Homepage_meet_india_find_transporter_web",
    Homepage_meet_india_find_transporter_after_lorry_selection:
        "Homepage_meet_india_find_transporter_after_lorry_selection_web",
    Homepage_vahak_media_selection: "Homepage_vahak_media_selection_web",
    Homepage_other_Activity: "Homepage_other_Activity_web",

    // Services Page Events
    Servicepage_user_type_of_service_page: "Servicepage_user_type_of_service_page_web",
    Servicepage_online_load_booking: "Servicepage_online_load_booking_web",
    Servicepage_online_truck_booking: "Servicepage_online_truck_booking_web",
    Servicepage_grow_network: "Servicepage_grow_network_web",
    Servicepage_logistics_services: "Servicepage_logistics_services_web",
    Servicepage_full_truck_load: "Servicepage_full_truck_load_web",
    Servicepage_part_truck_load: "Servicepage_part_truck_load_web",

    // Post Lorry
    Post_lorry_success: "Post_lorry_success_web",

    // Post Load
    Post_load_success: "Post_load_success_web",

    // Submit Bid
    Bid_submit_success: "bid_submit_success_web",

    // Submit Load Bid
    Load_bid_submit_success: "load_bid_submit_success_web",

    // Submit Lorry Bid
    Lorry_bid_submit_success: "lorry_bid_submit_success_web",

    // Accept Load Bid
    Load_bid_accept_success: "load_bid_accept_success_web",

    // Accept Lorry Bid
    Lorry_bid_accept_success: "lorry_bid_accept_success_web",

    // Business Card
    Share_business_card_clicked_web: "share_business_card_clicked_web",
    Download_business_card_clicked_web: "download_business_card_clicked_web",

    // App Download
    Download_app_clicked_web: "download_app_clicked_web",

    // Footer Subscribe
    Subscribe_clicked_web: "subscribe_clicked_web",

    // Language Selected
    Language_selected_web: "language_selected_web",

    // Contact Us Clicked
    Contact_us_clicked_web: "contact_us_clicked_web",

    // Connect Us
    Connect_with_us_clicked_web: "connect_with_us_clicked_web",

    // Avail Service
    Avail_logistic_service_clicked_web: "avail_logistic_service_clicked_web",

    // Call Now Btn
    Call_now_clicked_web: "call_now_clicked_web",

    // View Profile
    View_profile_clicked_web: "view_profile_clicked_web",

    // My Profile Page Events
    My_profile_go_back_clicked_web: "my_profile_go_back_clicked_web",
    My_profile_clicked: "my_profile_clicked",
    Edit_profile_clicked_web: "edit_profile_clicked_web",
    Profile_save_clicked_web: "profile_save_clicked_web",
    Vehicle_share_clicked_web: "vehicle_share_clicked_web",

    // My Post Filter
    My_posting_status_filter_clicked_web: "my_posting_status_filter_clicked_web",
    My_posting_advance_filter_apply_clicked_web: "my_posting_advance_filter_apply_clicked_web",

    // Load Lorry details
    Load_details_clicked_web: "load_details_clicked_web",
    Lorry_details_clicked_web: "lorry_details_clicked_web",

    // Bids Sent Received
    Bid_sent_received_clicked_web: "bid_sent_received_clicked_web",

    // Load Lorry Bid Now
    Load_bid_now_clicked_web: "load_bid_now_clicked_web",
    Lorry_bid_now_clicked_web: "lorry_bid_now_clicked_web",

    // Market Place Filter
    Marketplace_truck_filter_selected_web: "marketplace_truck_filter_selected_web",
    Marketplace_capacity_filter_web: "marketplace_capacity_filter_web",

    // Market Place City Search
    marketplace_source_city_entered_web: "marketplace_source_city_entered_web",
    marketplace_destination_city_entered_web: "marketplace_destination_city_entered_web",

    // Load Lorry Post Init
    Post_load_initiated_web: "post_load_initiated_web",
    Post_lorry_initiated_web: "post_lorry_initiated_web",

    // View & Choose True
    View_your_truck_type_web: "view_your_truck_type_web",
    Choose_your_truck_type_web: "choose_your_truck_type_web",

    // Admin Console Event Names
    USER_LOGIN_WEB: "user_login_web",
    CLIENT_PORTAL_VIEW_WEB: "client_portal_view_web",
    CLIENT_PROFILE_LOGIN_WEB: "client_profile_login_web",
    CLIENT_PROFILE_LOGOUT_WEB: "client_profile_logout_web",

    POST_LOAD_SUCCESS_WEB: "post_load_success_web",

    SEND_TO_CLIENT_CLICKED_WEB: "send_to_client_clicked_web",
    BID_NEGOTIATE_START_WEB: "Bid_negotiate_start_web",

    BID_NEGOTIATED_WEB: "bid_negotiated_web",
    BID_NEGOTIATION_BROADCASTED_WEB: "bid_negotiation_broadcasted_web",
    LORRY_BID_ACCEPT_SUCCESS_WEB: "lorry_bid_accept_success_web",
    UPDATE_DRIVER_DETAILS_WEB: "update_driver_details_web",
    LOGIN_OR_SIGNUP_BUTTON_CLICK_WEB: "login_signup_clicked",

    /**
     * Login/Signup Modal
     */
    LOGIN_OR_SIGNUP_MODAL: {
        wa_optin_toggled: "wa_optin_toggled",
        help_clicked: "help_clicked",
        custom_number_entered: "custom_number_entered",
        get_otp_clicked: "get_otp_clicked",
        otp_screen_edit_phone_number_clicked: "otp_screen_edit_phone_number_clicked",
        otp_via_message: "otp_via_message",
        otp_via_whatsapp: "otp_via_whatsapp",
        otp_submit: "otp_submit",
        user_login: "user_login",
        user_signup: "user_signup",
        close_clicked: "close_clicked",
        request_call_back_canceled: "request_call_back_canceled",
        requested_call_back: "requested_call_back"
    },
    COMPANY_REGISTRATION: {
        service_type_selected: "service_type_selected",
        company_name_entered: "company_name_entered",
        company_location_selected: "company_location_selected",
        have_a_referral_code_clicked: "have_a_referral_code_clicked",
        referral_code_entered: "referral_code_entered",
        company_details_submitted: "company_details_submitted",
        user_registered: "user_registered",
        continue_signup_banner: "continue_signup_banner"
    },
    SPLASH_SCREEN: {
        post_load_button_click: "post_load_button_click",
        add_lorry_attach_lorry_btn: "add_lorry_attach_lorry_btn"
    },
    /**
     * Membership Entry Point Event
     */

    MEMBERSHIP_ENTRY_POINT: {
        BANNER_CLICKED: "banner_clicked",
        LIMITATION_CARD_SHOWN: "limitation_card_shown",
        MEMBERSHIP_LIMITATION_CARD_CLOSE_CLICKED: "membership_limitation_card_close_clicked",
        BUY_MEMBERSHIP_CLICKED: "buy_membership_clicked",
        BUY_MEMBERSHIP_CARD_CLOSE_CLICKED: "buy_membership_card_close_clicked"
    },
    MEMBERSHIP_MANAGE: {
        MEMBERSHIP_PLAN_SELECTED: "membership_plan_selected",
        PAYMENT_START_PAYMENT_CLICK: "payment_start_payment_click",
        PAYMENT_FAILED: "payment_failed",
        PAYMENT_FAILED_CARD_SHOWN: "payment_failed_card_shown",
        PAYMENT_FAILED_CARD_CLOSE_CLICKED: "payment_failed_card_close_clicked",
        PAYMENT_RETRY_BTN_CLICK: "payment_retry_btn_click",
        PAYMENT_SUCCESS: "payment_success",
        PAYMENT_SUCCESS_CARD_SHOWN: "payment_success_card_shown",
        PAYMENT_SUCCESS_CARD_CLOSE_CLICKED: "payment_success_card_close_clicked",
        GOT_IT_CLICKED: "got_it_clicked",

        VIEW_HISTORY_CLICKED: "view_history_clicked",
        TOP_UP_RENEW_PLAN_CLICKED: "top_up_renew_plan_clicked"
    },

    /**
     * Lorry posting modal
     */

    LORRY_POSTING_MODAL: {
        view_live_loads_clicked: "view_live_loads_clicked",
        add_lorry_attach_lorry_btn: "add_lorry_attach_lorry_btn",
        //Not done
        enter_vehicle_no_attach_new_lorry_form: "enter_vehicle_no_attach_new_lorry_form",
        lorry_form_city_selected: "lorry_form_city_selected",
        // Not done
        verify_my_vehicle_clicked: "verify_my_vehicle_clicked",
        lorry_form_all_india_permit: "lorry_form_all_india_permit",
        lorry_form_see_more_route_click: "lorry_form_see_more_route_click",
        lorry_form_route_pop_up_save_click: "lorry_form_route_pop_up_save_click",
        lorry_form_next_click: "lorry_form_next_click",
        lorry_form_edit_click: "lorry_form_edit_click",
        // Not done
        lorry_form_update_click: "lorry_form_update_click",
        // Not done
        not_my_vehicle_clicked: "not_my_vehicle_clicked",
        lorry_form_vehicle_added: "lorry_form_vehicle_added",
        lorry_form_capacity_selection: "lorry_form_capacity_selection",
        lorry_form_body_type_selection: "lorry_form_body_type_selection",
        lorry_form_tyres_selection: "lorry_form_tyres_selection",
        document_upload_clicked: "document_upload_clicked",
        lorry_form_attach_post_click: "lorry_form_attach_post_click",
        lorry_attached_successfully: "lorry_attached_successfully",
        reactivated_lorry: "reactivated_lorry"
    },

    /**
     * lorry listing
     */

    LORRY_LISTING: {
        bs_close_clicked: "bs_close_clicked",
        lorry_form_city_selected: "lorry_form_city_selected",
        lorry_form_reactivate_click: "lorry_form_reactivate_click"
    },
    // Marketplace
    MARKET_PLACE: {
        marketplace_load_market_selected: "marketplace_load_market_selected",
        marketplace_lorry_market_selected: "marketplace_lorry_market_selected",
        marketplace_source_city_entered: "marketplace_source_city_entered",
        marketplace_destination_city_entered: "marketplace_destination_city_entered",
        filters_clicked: "filters_clicked",
        filters_selected: "filters_selected",
        change_preference_clicked: "change_preference_clicked",
        preference_selected: "preference_selected",
        filters_cleared: "filters_cleared",
        search_by_cities_clicked: "search_by_cities_clicked",
        book_now: "book_now",
        bs_close_clicked: "bs_close_clicked",
        continue_bidding: "continue_bidding",
        canceled_bidding: "canceled_bidding",
        request_call_back_clicked: "request_call_back_clicked",
        close_clicked: "close_clicked",
        request_call_back_canceled: "request_call_back_canceled",
        requested_call_back: "requested_call_back",
        connect_on_wa_clicked: "connect_on_wa_clicked",
        bid_amount_entered: "bid_amount_entered",
        remarks_entered: "remarks_entered",
        bid_submitted: "bid_submitted",
        load_bid_submitted: "load_bid_submitted",
        lorry_bid_submitted: "lorry_bid_submitted",
        post_load_button_click: "post_load_button_click",
        load_selected: "load_selected",
        reposted_load: "reposted_load",
        view_profile_clicked: "view_profile_clicked",
        verification_badge_clicked: "verification_badge_clicked",
        edit_operating_states: "edit_operating_states",
        edit_operating_states_saved: "edit_operating_states_saved",
        add_lorry_attach_lorry_btn: "add_lorry_attach_lorry_btn",
        bid_ignored: "bid_ignored",
        marketplace_search_clicked: "marketplace_search_clicked",
        select_from_existing_clicked: "select_from_existing_clicked"
    },

    /**
     * Profile Events
     */
    PROFILE_PAGE: {
        help_clicked: "help_clicked",
        profile_add_dp_clicked: "profile_add_dp_clicked",
        view_business_card_clicked: "view_business_card_clicked",
        share_business_card: "share_business_card",
        banner_clicked: "banner_clicked",
        add_lorry_attach_lorry_btn: "add_lorry_attach_lorry_btn",
        post_load_button_click: "post_load_button_click",
        view_verification_clicked: "view_verification_clicked",
        bs_close_clicked: "bs_close_clicked",
        got_it_clicked: "got_it_clicked",
        add_bank_account_clicked: "add_bank_account_clicked",
        request_call_back_canceled: "request_call_back_canceled",
        requested_call_back: "requested_call_back",
        bank_account_verify_using_clicked: "bank_account_verify_using_clicked",
        verify_bank_account_clicked: "verify_bank_account_clicked",
        bank_account_added: "bank_account_added",
        manage_account_clicked: "manage_account_clicked",
        delete_bank_account_clicked: "delete_bank_account_clicked",
        bank_account_deleted: "bank_account_deleted",
        edit_profile_clicked: "edit_profile_clicked",

        edit: {
            founding_year_selected: "founding_year_selected",
            languages_confirmed: "languages_confirmed",
            edit_operating_states: "edit_operating_states",
            about_us_saved: "about_us_saved",
            change_address_clicked: "change_address_clicked",
            office_location_selected: "office_location_selected",
            office_open_time_selected: "office_open_time_selected",
            working_days_selected: "working_days_selected",
            office_close_time_selected: "office_close_time_selected",
            profile_save_clicked: "profile_save_clicked"
        }
    },
    KYC: {
        verify_aadhar_clicked: "verify_aadhar_clicked",
        get_otp_clicked: "get_otp_clicked",
        otp_submit: "otp_submit",
        kyc_completed_aadhar: "kyc_completed_aadhar",
        kyc_aadhar_verification_failed: "kyc_aadhar_verification_failed",
        verify_pan_clicked: "verify_pan_clicked",
        submit_clicked: "submit_clicked",
        kyc_completed_pan: "kyc_completed_pan",
        kyc_pan_verification_failed: "kyc_pan_verification_failed",
        kyc_completed_gst: "kyc_completed_gst",
        kyc_gst_verification_failed: "kyc_gst_verification_failed"
    },
    TRANSPORTER_PROFILE: {
        call_initiated: "call_initiated",
        view_verification_clicked: "view_verification_clicked",
        got_it_clicked: "got_it_clicked",
        profile_banner_clicked: "profile_banner_clicked",
        profile_load_clicked: "profile_load_clicked",
        profile_lorry_clicked: "profile_lorry_clicked"
    },

    // Top nav events
    TOP_NAV: {
        manage_membership_clicked: "manage_membership_clicked",
        marketplace_icon_clicked: "marketplace_icon_clicked",
        transport_directory_clicked: "transport_directory_clicked",
        download_app_clicked_web: "download_app_clicked_web",
        login_signup_clicked: "login_signup_clicked"
    },

    /** Web v2 unified funnel events — use `WEB_V2_SOURCE_SCREENS` for source_screen attribute. */
    WEB_V2: {
        title_find_loads_clicked: "title_find_loads_clicked",
        title_find_lorry_clicked: "title_find_lorry_clicked",
        title_download_app_clicked: "title_download_app_clicked",
        title_membership_clicked: "title_membership_clicked",
        title_cargo_insurance_clicked: "title_cargo_insurance_clicked",
        title_login_signup: "title_login/signup",
        title_language_change: "title_language_change",

        marketplace_page_opened: "marketplace_page_opened",
        cargo_insurance_page_opened: "cargo_insurance_page_opened",
        membership_page_opened: "membership_page_opened",

        pick_up_entered: "pick_up_entered",
        drop_entered: "drop_entered",
        capacity_entered: "capacity_entered",
        lorry_type_selected: "lorry_type_selected",
        check_prices_clicked: "check_prices_clicked",

        load_form_location_page_opened: "load_form_location_page_opened",
        load_form_next_step_1_clicked: "load_form_next_step_1_clicked",
        load_form_spec_page_opened: "load_form_spec_page_opened",
        load_form_next_step_2_clicked: "load_form_next_step_2_clicked",
        load_form_price_page_opened: "load_form_price_page_opened",
        load_post_successfully: "load_post_successfully",
        load_post_successfully_priority: "load_post_successfully_priority",
        download_appstore: "download_appstore",
        download_playstore: "download_playstore",

        login_sign_up_form_opened: "login_sign_up_form_opened",
        phone_number_entered: "phone_number_entered",
        get_otp_clicked: "get_otp_clicked",
        otp_entered: "otp_entered",
        otp_submit: "otp_submit",
        user_signup: "user_signup",
        user_registered: "user_registered",

        book_now: "book_now",
        stop_clicked: "stop_clicked",
        bid_form_basic_opened: "bid_form_basic_opened",
        bid_form_show_route_clicked: "bid_form_show_route_clicked",
        bid_form_price_increased: "bid_form_price_increased",
        bid_form_disclaimer_checked: "bid_form_disclaimer_checked",
        bid_form_disclaimer_unchecked: "bid_form_disclaimer_unchecked",
        bid_form_basic_next: "bid_form_basic_next",
        bid_form_detailed_opened: "bid_form_detailed_opened",
        use_coins_toggled: "use_coins_toggled",
        payment_pay_now_btn: "payment_pay_now_btn",
        bid_submitted: "bid_submitted",
        bid_submitted_priority: "bid_submitted_priority",
        payment_success: "payment_success",
        bs_closed: "bs_closed",
        view_more_loads_clicked: "view_more_loads_clicked",

        cargo_form_name_entered: "cargo_form_name_entered",
        cargo_form_number_entered: "cargo_form_number_entered",
        cargo_form_submitted: "cargo_form_submitted",

        market_search_clicked: "market_search_clicked",

        buy_now_clicked: "Buy_now_clicked"
    },

    //Sidenav events
    SIDE_NAV: {
        post_btn_clicked: "post_btn_clicked",
        post_load_button_click: "post_load_button_click",
        add_lorry_attach_lorry_btn: "add_lorry_attach_lorry_btn",
        homepage_icon_clicked: "homepage_icon_clicked",
        my_load_icon_clicked: "my_load_icon_clicked",
        my_lorry_icon_clicked: "my_lorry_icon_clicked",
        marketplace_icon_clicked: "marketplace_icon_clicked",
        transport_directory_clicked: "transport_directory_clicked",
        services_icon_clicked: "services_icon_clicked",
        meet_vahak_icon_clicked: "meet_vahak_icon_clicked",
        resource_icon_clicked: "resource_icon_clicked",
        manage_membership_clicked: "manage_membership_clicked",
        profile_menu_clicked: "profile_menu_clicked",
        profile_icon_clicked: "profile_icon_clicked",
        user_logout: "user_logout"
    },

    // Third party events
    THIRD_PARTY: {
        third_party_login: "third_party_login"
    },

    //Transporter directory

    TRANSPORT_DIRECTORY: {
        transport_directory_source_city_entered: "transport_directory_source_city_entered",
        transport_directory_destination_city_entered: "transport_directory_destination_city_entered",
        transport_directory_search_by_name_entered: "transport_directory_search_by_name_entered"
    }
};

export const NOT_APPLICABLE = "#N/A";

/** Standard source_screen values for WEB_V2 funnel events. */
export const WEB_V2_SOURCE_SCREENS = {
    HOME_PAGE: "home_page",
    LOAD_FORM: "load_form",
    ONB_FORM: "onb_form",
    BID_FORM: "bid_form",
    MARKETPLACE: "marketplace",
    CARGO_INSURANCE: "cargo_insurance",
    MEMBERSHIP: "membership",
    LCV_ROUTE_LANDING: "lcv_route_landing",
    LCV_CITY_LANDING: "lcv_city_landing"
} as const;

// Home Page button click Event Values
export const GA4HomePageBtnClickEventValues = {
    without_login: 0,
    after_login: 1
};

// Home Page button click Event Values
export const GA4HomePageBtnClickLocationEventValues = {
    service_pages: 1,
    marketplace: 2,
    transport_directory: 3,
    company_pages: 5,
    business_card: 6
};

// Home Page what can we do Event Values
export const GA4HomePageWhatCanWeDoEventValues = {
    search_load: 0,
    search_lorries: 1,
    browse_transporters: 2
};

// Home Page meet india transporter service providers change_city after selection Event Values
export const GA4HomePageMeetTransportServiceProvidersEventValues = {
    get_contact_details: 0,
    view_profile: 1,
    next_in_same_page: 2,
    view_full_list: 3
};

// Home Page meet india book right load for you Event Values
export const GA4HomepageBookRightLoadEventValues = {
    3: 0,
    5: 1,
    1: 2,
    4: 3,
    2: 4,
    6: 5
};

// Home Page meet india after book right load for you Event Values
export const GA4HomepageBookRightLoadAfterLorryCategorySelectionEventValues = {
    view_profile: 0,
    bid_now: 1,
    view_full_list: 2
};

// Home Page Find top transport services near you Event Values
export const GA4HomepageFindTransporterEventValues = {
    3: 0,
    5: 1,
    1: 2,
    4: 3,
    2: 4,
    6: 5
};

// Home Page Find top transport services near you after choosing  Event Values
export const GA4HomepageFindTransporterAfterLorrySelectionEventValues = {
    view_profile: 0,
    bid_now: 1,
    view_full_list: 2
};

// Home Page Media section Event Values
export const GA4HomepageVahakMediaSelectionEventValues = {
    recommended_video: 1,
    view_all_videos: 2
};

// Home Page Other Event Values
export const GA4HomepageOtherActivityEventValues = {
    testimonial: 1,
    playstore: 2,
    transporter_bytes: 3,
    vahak_in_the_news: 4
};

// Header Nav Service sub menu Event Values
export const GA4HeaderServiceEventValues = {
    online_load_booking: 0,
    online_lorry_booking: 1,
    grow_network: 2,
    logistics_services: 3,
    full_truck_load: 4,
    part_truck_load: 5,
    business_cards: 6
};

// Service Page online load booking Event Values
export const GA4ServicePageOnlineLoadBookingEventValues = {
    book_loads_now: 1,
    start_booking_now: 2,
    mobile_app: 3,
    web: 4,
    type_of_truck_loads_find_now: 5
};

// Service Page online truck booking Event Values
export const GA4ServicePageOnlineTruckBookingEventValues = {
    book_trucks_now: 1,
    start_booking_now: 2,
    mobile_app: 3,
    web: 4,
    book_lorries: 5
};

// Service Page grow network Event Values
export const GA4ServicePageGrowNetworkEventValues = {
    start_networking: 1,
    grow_network: 2,
    mobile_app: 3,
    web: 4
};

// Service Page logistics services Event Values
export const GA4ServicePageLogisticsServicesEventValues = {
    avail_logistics_sercives: 1,
    find_trucks_online: 2,
    mobile_app: 3,
    web: 4
};

// Service Page full truck load Event Values
export const GA4ServicePageFullTruckLoadEventValues = {
    book_full_truck_load: 1,
    explore_ftl_market: 2,
    mobile_app: 3,
    web: 4
};

// Service Page part truck load Event Values
export const GA4ServicePagePartTruckLoadEventValues = {
    book_part_load: 1,
    explore_part_load_market: 2,
    mobile_app: 3,
    web: 4
};

// Load posting event source values
export const GA4LoadPostingSource = {
    home_screen_bid_now: "Home screen bid now",
    marketplace_live_lorry_bid_now: "Marketplace live lorry bid now",
    my_loads_post_load: "My loads post load"
};

// Load posting event source values
export const GA4LorryPostingSource = {
    home_screen_bid_now: "Home screen bid now",
    marketplace_live_load_bid_now: "Marketplace live load bid now",
    my_lorries_post_lorry: "My lorries post lorry"
};

// Lorry bid event source values
export const moEngageLorryBidSource = {
    home_screen_lorry_bid: "Home screen lorry bid",
    marketplace_lorry_bid: "Marketplace lorry bid"
};

// Load bid event source values
export const moEngageLoadBidSource = {
    home_screen_load_bid: "Home screen load bid",
    marketplace_load_bid: "Marketplace load bid"
};
// Bid Submit event source values
export const GA4BidSubmitSource = {
    home_page: "Home page",
    load_market: "Load market",
    lorry_market: "Lorry market"
};

// Business event source values
export const GA4BusinessCardSource = {
    homescreen: "Homescreen",
    my_profile_section: "My profile section"
};

// APP click event source values
export const GA4AppClickSource = {
    homepage_bottom_screen: "Homepage bottom screen",
    homepage_middle_section: "Homepage Middle section",
    profile_page: "profile Page"
};

// Contact Us click event source values
export const GA4ContactUsClickSource = {
    homepage_bottom_section: "Homepage bottom section",
    homepage_top_section: "Homepage top section"
};

// Bid Now click event source values
export const GA4BidNowClickSource = {
    homepage: "Homepage",
    load_market: "Load Market",
    lorry_market: "Lorry Market"
};

// Market Place filter click event source values
export const GA4MarketPlaceFilterClickSource = {
    load_market: "Load Market",
    lorry_market: "Lorry Market"
};

// Call Btn click event source values
export const GA4CallBtnClickSource = {
    homepage: "Homepage",
    profile_page: "Profile page"
};

// Post Load or Lorry click event source values
export const GA4PostLoadLorryInitClickSource = {
    my_loads_section: "My loads section",
    my_lorry_section: "My lorry section",
    post_button: "post button on my dashboard"
};

// View All click event source values
export const GA4ViewAllClickSource = {
    loads: "Loads",
    lorry: "Lorry"
};

// Login button click & login modal event attributes
export const GA4LoginOrRegistrationModalEventAttributes = {
    phone_number_registration: "phone_number_registration",
    first_time_user: "first_time_user",
    repeated_user: "repeated_user",
    login_signup_via: "manual"
};

export const GA4MembershipEventAttributes = {
    NEW_MEMBERSHIP: "new_membership",
    HOMEPAGE: "homepage",
    EXPLORE_NOW: "explore_now",
    EXPLORE_YOUR_MEMBERSHIP: "explore_your_membership",
    MANAGE: "manage",
    YOUR_MEMBERSHIP: "your_membership",
    TOP_UP_PLAN: "top_up_plan",
    VIEW_OTHER_PLANS: "view_other_plans",

    BUY_MEMBERSHIP: "buy_membership",
    UPGRADE_MEMBERSHIP: "upgrade_membership",
    NEW_MEMBERSHIP_PLAN: "new_membership_plan",
    MEMBERSHIP_PLAN_UPGRADE: "membership_plan_upgrade",
    MEMBERSHIP_PLAN_RENEWAL: "membership_plan_renewal",
    MEMBERSHIP_PLAN_TOPUP: "membership_plan_topup",

    MEMBERSHIP: "membership",
    TOP_UP: "top_up",
    RENEW: "renew",

    MEMBERSHIP_PLAN_LIMIT_EXHAUST: "membership_plan_limit_exhaust",
    MEMBERSHIP_FREE_TRAIL_EXHAUST: "membership_free_trail_exhaust",
    PLAN_LIMIT_EXHAUST: "plan_limit_exhaust",
    FREE_TRAIL_EXHAUST: "free_trail_exhaust",
    UPGRADE: "upgrade"
};

export const VWOEvents = {
    sign_up_success: "sign_up",
    login_success: "login_success",
    bid_success: "bid_success",
    post_lorry_success: "post_lorry_success",
    post_load_success: "post_load_success"
};

export const GA4EventNamesAdminConsole = {
    /**
     * Admin sidenav
     */

    ADMIN_USER_TYPE: {
        TSO: "tso"
    },

    SIDE_NAV: {
        home_clicked: "home_clicked",
        load_posted_clicked: "load_posted_clicked",
        intransit_loads_clicked: "intransit_loads_clicked",
        lorry_posted_clicked: "lorry_posted_clicked",
        intransit_lorries_clicked: "intransit_lorries_clicked",
        load_enquirycards_clicked: "load_enquirycards_clicked",
        lorry_enquirycards_clicked: "lorry_enquirycards_clicked",
        loadmarket_clicked: "loadmarket_clicked",
        lorrymarket_clicked: "lorrymarket_clicked",
        myusers_clicked: "myusers_clicked",
        claimuser_clicked: "claimuser_clicked"
    },

    /**
     * Event attribute
     */
    TSO_SOURCE_SCREEN: {
        tso_side_nav_bar: "tso_side_nav_bar",
        tso_home: "tso_home",
        tso_load_posted: "tso_load_posted",
        tso_intransit_loads: "tso_intransit_loads",
        tso_lorry_posted: "tso_lorry_posted",
        tso_intransit_lorries: "tso_intransit_lorries",
        tso_load_enquirycards: "tso_load_enquirycards",
        tso_lorry_enquirycards: "tso_lorry_enquirycards",
        tso_load_market: "tso_load_market",
        tso_lorry_market: "tso_lorry_market",
        tso_my_users: "tso_my_users",
        tso_claim_users: "tso_claim_users",
        tso_load_listings: "tso_load_listings",
        tso_intransit_load_listings: "tso_intransit_load_listings",
        tso_lorry_listings: "tso_lorry_listings",
        tso_intransit_lorry_listings: "tso_intransit_lorry_listings"
    },

    //Active loads
    TSO_LOAD_POSTED_SCREEN: {
        searchby_selected: "searchby_selected",
        onchange_search_input: "onchange_search_input",
        editload_clicked: "editload_clicked",
        verifyload_clicked: "verifyload_clicked",
        load_card_clicked: "load_card_clicked",
        call_initiated: "call_initiated"
    },
    //In transit loads
    TSO_IN_TRANSIT_LOAD_SCREEN: {},

    TSO_LOAD_DETAILS_SCREEN: {
        removed_from_market: "removed_from_market",
        bids_clicked: "bids_clicked",
        view_live_lorries_clicked: "view_live_lorries_clicked",
        filters_selected: "filters_selected",
        view_details: "view_details"
    },

    //Active lorries
    TSO_LORRY_POSTED_SCREEN: {
        searchby_selected: "searchby_selected",
        onchange_search_input: "onchange_search_input",
        editlorry_clicked: "editlorry_clicked",
        verifylorry_clicked: "verifylorry_clicked",
        lorry_card_clicked: "lorry_card_clicked",
        call_initiated: "call_initiated"
    },
    //In transit loads
    TSO_IN_TRANSIT_LORRY_SCREEN: {},
    TSO_LORRY_DETAILS_SCREEN: {
        removed_from_market: "removed_from_market",
        bids_clicked: "bids_clicked",
        view_live_loads_clicked: "view_live_loads_clicked",
        filters_selected: "filters_selected",
        view_details: "view_details"
    },
    TSO_USER_PROFILE: {
        searchby_selected: "searchby_selected",
        view_profile_clicked: "view_profile_clicked",
        call_initiated: "call_initiated",
        filters_selected: "filters_selected"
    }
};

export const LoadScreenEvents = {
    load_listing_clicked: "load_listing_clicked",
    my_bids_clicked: "my_bids_clicked",
    post_load_button_click: "post_load_button_click",
    filters_clicked: "filters_clicked",
    filters_selected: "filters_selected",
    repost_load_clicked: "repost_load_clicked",
    load_card_clicked: "load_card_clicked",
    shareonwhatsapp_clicked: "shareonwhatsapp_clicked",
    sharedonwhatsapp: "sharedonwhatsapp",
    details_clicked: "details_clicked"
};

export const LorryScreenEvents = {
    ...LoadScreenEvents,
    lorry_listing_clicked: "lorry_listing_clicked",
    my_bids_clicked: "my_bids_clicked",
    add_lorry_attach_lorry_btn: "add_lorry_attach_lorry_btn",
    lorry_card_clicked: "lorry_card_clicked",
    reactivate_lorry_clicked: "reactivate_lorry_clicked",
    document_upload_clicked: "document_upload_clicked",
    document_uploaded: "document_uploaded",
    reactivated_lorry: "reactivated_lorry"
};

export const BidCardEvents = {
    bid_card_clicked: "bid_card_clicked",
    bid_negotiate_clicked: "bid_negotiate_clicked",
    bid_accept_clicked: "bid_accept_clicked",
    cancel_bidding: "cancel_bidding",
    bid_accepted: "bid_accepted",
    bid_amount_entered: "bid_amount_entered",
    attach_lorry_clicked: "attach_lorry_clicked",
    add_lorry_attach_lorry_btn: "add_lorry_attach_lorry_btn",
    lorry_and_driver_details_added: "lorry_and_driver_details_added",
    call_initiated: "call_initiated",
    bid_negotiated: "bid_negotiated",
    load_bid_negotiated: "load_bid_negotiated",
    lorry_bid_negotiated: "lorry_bid_negotiated",
    select_from_existing_clicked: "select_from_existing_clicked",
    lorry_attached_successfully: "lorry_attached_successfully"
};

export const LoadPostingFormEvents = {
    pickup_location_initiated_loadform: "pickup_location_initiated_loadform",
    drop_location_initiated_loadform: "drop_location_initiated_loadform",
    load_form_material_name_entered: "load_form_material_name_entered",
    load_form_quantity_entered: "load_form_quantity_entered",
    load_form_capacity_entered: "load_form_capacity_entered",
    load_form_next_step_1_click: "load_form_next_step_1_click",
    load_form_edit_step_1_click: "load_form_edit_step_1_click",
    load_form_update_step_1_click: "load_form_update_step_1_click",
    load_form_vehicle_added: "load_form_vehicle_added",
    load_form_body_type_selection: "load_form_body_type_selection",
    load_form_tyres_selection: "load_form_tyres_selection",
    load_form_next_step_2_click: "load_form_next_step_2_click",
    load_form_edit_step_2_click: "load_form_edit_step_2_click",
    load_form_update_step_2_click: "load_form_update_step_2_click",
    load_post_payment_type: "load_post_payment_type",
    load_form_advance_enter: "load_form_advance_enter",
    load_form_expected_price_enter: "load_form_expected_price_enter",
    load_form_odc_selected: "load_form_odc_selected",
    load_form_odc_length_entered: "load_form_odc_length_entered",
    load_form_odc_breadth_entered: "load_form_odc_breadth_entered",
    load_form_odc_height_entered: "load_form_odc_height_entered",
    load_form_post_repost_load_button_click: "load_form_post_repost_load_button_click",
    load_post_successfully: "load_post_successfully",
    load_post_failure: "load_post_failure",
    view_live_lorries_clicked: "view_live_lorries_clicked",
    total_load_post: "total_load_post",
    load_lorry_post_repost_success: "load_lorry_post_repost_success",
    reposted_load: "reposted_load"
};
export const AssuredLoadEvents = {
    payment_pay_now_btn: "payment_pay_now_btn",
    payment_success: "payment_success"
};

export const AdminMiscEvents = {
    admin_notification_trigger: "admin_notification_trigger",
    admin_send_journey_feedback: "admin_send_journey_feedback"
};
